import React from 'react'

const Ofertas = () => {
  return (
    <div className='flex h-screen text-xl'>OFERTAS
    <div className='h-screen'></div></div>
  )
}

export default Ofertas